<template>
  <div class="aboutWrapper">
    <dwgwcontenheader :imgsrc="img"></dwgwcontenheader>
    <dwgwcontenstabs :contentsList="contentsList">
        <img class="xiaomishuImg" src="./jpg/xiaomishu.jpg" alt="">
    </dwgwcontenstabs>
  </div>
</template>

<script>
import dwgwcontenheader from "@/components/dwgwcontenheader";
import dwgwcontenstabs from "@/components/dwgwcontenstabs";
export default {
  name: "dwgwabout",
  components: {
    dwgwcontenheader,
    dwgwcontenstabs,
  },
  data() {
    return {
      img: require("./jpg/index1_4.png"),
      contentsList: [
        {
          title: "蝶威产品",
          contentData: ["查阅蝶威量化产品周报，请关注微信公众号“蝶威量化”。（扫码即可关注）"],
        }
      ],
    };
  },
};
</script>

<style scoped>
.aboutWrapper {
  width: 1140px;
  margin: 0 auto;
  margin-top: 100px;
}
.xiaomishuImg{
    width: 50%;
}
</style>


// WEBPACK FOOTER //
// src/components/dwgwcp.vue